import styles from './feature-icons.module.scss'

import Tooltip from 'components/tooltip/tooltip'
import Svg from 'components/svg/svg'
import { cn } from 'utils/helpers'

export default function FeatureIcons({ features, from = 'account' }) {
    return (
        <div className={cn(styles.features, !features.length && styles.empty, styles[from])}>
            {features.map((feature, k) => (
                <Tooltip key={k} content={feature.name}>
                    <div className={styles.feature}>
                        <Svg
                            name={`feature-${feature.slug}`}
                            className={cn(styles.icon, styles[feature.slug.replace(/-/g, '')])}
                        />
                    </div>
                </Tooltip>
            ))}
        </div>
    )
}
